// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-discount-section-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
}
.modal-discount-section-wrapper .alert-warning {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 12px;
}
.modal-discount-section-wrapper .discount-input-wrapper label {
  font-size: 16px;
  color: #595C5F;
}
.modal-discount-section-wrapper .discount-input-wrapper div {
  position: relative;
}
.modal-discount-section-wrapper .discount-input-wrapper div span {
  position: absolute;
  top: 8%;
  color: #aeaeae;
  font-size: 20px;
}
.modal-discount-section-wrapper .discount-input-wrapper div input {
  outline: none;
  font-size: 15px;
  font-weight: 400;
  color: #000;
  padding: 0 4px 0 16px;
  border-bottom: 1px solid #d0566e;
}
.modal-discount-section-wrapper .discount-input-wrapper div input::placeholder {
  color: #aeaeae;
}
.modal-discount-section-wrapper .discount-textarea-wrapper label {
  font-size: 16px;
  color: #595C5F;
}
.modal-discount-section-wrapper .discount-textarea-wrapper textarea {
  appearance: none;
  border: 1px solid #ddd;
  border-radius: 2px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
  padding: 0 4px;
  resize: none;
}
.modal-discount-section-wrapper .discount-textarea-wrapper textarea::placeholder {
  color: #aeaeae;
}
.modal-discount-section-wrapper .discount-textarea-wrapper textarea:focus-visible {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ViewDetailModal/DiscountSection/style.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACR;AAGQ;EACI,eAAA;EACA,cAAA;AADZ;AAIQ;EACI,kBAAA;AAFZ;AAGY;EACI,kBAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;AADhB;AAGY;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,gCAAA;AADhB;AAGgB;EACI,cAAA;AADpB;AAQQ;EACI,eAAA;EACA,cAAA;AANZ;AASQ;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AAPZ;AASY;EACI,cAAA;AAPhB;AAUY;EACI,aAAA;AARhB","sourcesContent":[".modal-discount-section-wrapper {\n    border: 1px solid #ddd;\n    border-radius: 6px;\n\n    .alert-warning{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        line-height: 12px;\n    }\n\n    .discount-input-wrapper {\n        label {\n            font-size: 16px;\n            color: #595C5F;\n        }\n\n        div{\n            position: relative;\n            span{\n                position: absolute;\n                top: 8%;\n                color: #aeaeae;\n                font-size: 20px;\n            }\n            input {\n                outline: none;\n                font-size: 15px;\n                font-weight: 400;\n                color: #000;\n                padding: 0 4px 0 16px;\n                border-bottom: 1px solid #d0566e;\n    \n                &::placeholder {\n                    color: #aeaeae;\n                }\n            }\n        }\n    }\n\n    .discount-textarea-wrapper {\n        label {\n            font-size: 16px;\n            color: #595C5F;\n        }\n\n        textarea {\n            appearance: none;\n            border: 1px solid #ddd;\n            border-radius: 2px;\n            font-size: 16px;\n            font-weight: 400;\n            color: #000;\n            padding: 0 4px;\n            resize: none;\n\n            &::placeholder {\n                color: #aeaeae;\n            }\n\n            &:focus-visible{\n                outline: none;;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
